import React, { useState } from 'react';
import {
    Card,
    CardContent,
    TextField,
    Button,
    Box,
    Typography,
    Alert,
    CircularProgress,
} from '@mui/material';
import { useRedirect } from 'react-admin';
import SearchIcon from '@mui/icons-material/Search';
import { useNotify } from 'react-admin';

export const OrdersSearchPage: React.FC = () => {
    const [searchValue, setSearchValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const redirect = useRedirect();
    const notify = useNotify();

    const handleSearch = async () => {
        if (!searchValue.trim()) {
            setError('Пожалуйста, введите номер заказа или идентификатор');
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            // Просто переходим на страницу заказа - данные будут загружены там
            redirect('show', 'orders', searchValue);

        } catch (error) {
            console.error('Navigation error:', error);
            setError('Ошибка при переходе к заказу');
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyPress = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <Box sx={{ p: 3, maxWidth: 1200 }}>
            <Card>
                <CardContent>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Поиск заказа
                    </Typography>
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Введите номер заказа (число) или идентификатор заказа для поиска
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <TextField
                            fullWidth
                            label="Номер заказа или идентификатор"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyPress={handleKeyPress}
                            disabled={isLoading}
                            placeholder="Например: 1751725741 или 686934dff01db5688b548791"
                            variant="outlined"
                        />
                        
                        <Button
                            variant="contained"
                            onClick={handleSearch}
                            disabled={isLoading || !searchValue.trim()}
                            startIcon={isLoading ? <CircularProgress size={20} /> : <SearchIcon />}
                            sx={{ minWidth: 120, height: 36 }}
                        >
                            {isLoading ? 'Поиск...' : 'Найти'}
                        </Button>
                    </Box>

                    <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                        • Номер заказа: числовое значение (например: 1751725741)<br/>
                        • Идентификатор: строка с дефисами (например: 686934dff01db5688b548791)
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};
